import { render, staticRenderFns } from "./PromotionDiscountFreebie.vue?vue&type=template&id=1becc225&"
import script from "./PromotionDiscountFreebie.vue?vue&type=script&lang=js&"
export * from "./PromotionDiscountFreebie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports